import { useState } from "react";
import PieChart from "../../../../../Components/Charts/PieChart";
import {
  PieData,
  PieData1,
  PieData2,
} from "../../../../../Components/Charts/Data";

const MatrixChart = ({ stats }) => {
  var yValues = [90, 10];
  const [pieData, setPieData] = useState({
    labels: PieData.map((data) => data?.pillar),
    datasets: [
      {
        label: false,
        data: yValues,
        backgroundColor: ["#FF92DB", "#fff"],
        borderWidth: 12,
        borderColor: "#fff",
        borderRadius: stats?.livePrograms,
      },
    ],
    text: "23%",
  });

  const [pieData1, setPieData1] = useState({
    labels: PieData1.map((data) => data?.pillar),
    datasets: [
      {
        label: false,
        data: [60, 40],
        backgroundColor: ["#FF92DB", "#fff"],
        borderWidth: 12,
        borderColor: "#fff",
        borderRadius: 20,
      },
    ],
  });

  const [pieData2, setPieData2] = useState({
    labels: PieData2.map((data) => data?.pillar),
    datasets: [
      {
        label: false,
        data: [80, 20],
        backgroundColor: ["#FF92DB", "#fff"],
        borderWidth: 12,
        borderColor: "#fff",
        borderRadius: 20,
      },
    ],
  });

  return (
    <div className="card shadow  py-md-3 px-md-2 p-lg-3 border-0">
      <p className="hdng-para mb-0 pb-1">Learning Program specific metrics</p>
      <div className="circular-charts d-flex">
        <div className="chart-inr">
          <div className="chart">
            <PieChart chartData={pieData} text={stats?.livePrograms ?? 0} />
          </div>
          <div className="chart-text">
            <p className="mb-0 text-center">
              LIVE Programs enrolled by students
            </p>
          </div>
        </div>
        <div className="chart-inr">
          <div className="chart">
            <PieChart
              chartData={pieData1}
              text={stats?.studentPerLiveProgram ?? 0}
            />
          </div>
          <div className="chart-text">
            <p className="mb-0 text-center">Students per LIVE Program</p>
          </div>
        </div>
        <div className="chart-inr">
          <div className="chart">
            <PieChart
              chartData={pieData2}
              text={parseInt(stats?.averageSubmission ?? 0)}
            />
          </div>
          <div className="chart-text">
            <p className="mb-0 text-center">
              Average Submissions made per LIVE Program
            </p>
          </div>
        </div>
        <div className="chart-inr">
          <div className="chart">
            <PieChart
              chartData={pieData}
              text={parseInt(stats?.averageScore ?? 0)}
            />
          </div>
          <div className="chart-text">
            <p className="mb-0 text-center">Average score per LIVE Program</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatrixChart;
